import { debounce } from "../helpers/debounce";

updateScrollbarWidth();
window.addEventListener("load", updateScrollbarWidth);
window.addEventListener("resize", debounce(updateScrollbarWidth));

function updateScrollbarWidth() {
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`,
  );
}
